<template>
  <div>
    <div v-if="client" class="mgb-40px level">
      <div class="level-left is-flex-direction-column is-align-items-flex-start">
        <p class="is-size-4  has-text-weight-semibold has-text-default">
            {{$t('cartographie.cards.client.client')}}
          <span class="has-text-primary">
            {{client.nomCommercial}}
          </span>
        </p>
        <p class="has-text-default has-text-weight-semibold">
          {{$t('cartographie.cards.client.code')}}: {{client.code}}
        </p>
      </div>
      <div class="level-right">
        <qd-button
        :type="streetView ? '' : 'is-primary'"
        @click="toggleStreetView">
          {{streetView ?
            $t('cartographie.cards.client.retour')
            : $t('cartographie.cards.client.streetView')}}
        </qd-button>
      </div>
    </div>
    <div v-if="!streetView" class="columns">
      <div class="column is-4 pd-10px">
        <img class="width-100percent" v-if="logo" :src="logo">
      </div>
      <div class="coulmn is-8 pdh-10px width-100percent">
        <p class="is-size-4 has-text-default has-text-weight-semibold mgb-20px">
          {{$t('cartographie.cards.client.informations')}}
        </p>
        <div class="columns">
          <div class="column is-12">
            <div class="mgb-20px">
              <p class="has-text-default is-italic">
                {{$t('cartographie.cards.client.adressePostale')}}
              </p>
              <p class="has-text-default has-text-weight-semibold">
                {{adresse.intitule1}}
                {{adresse.intitule2}}
                {{adresse.intitule3}}
                <br v-if="adresse.intitule1">
                {{adresse.adresse1}}
                {{adresse.adresse2}}
                {{adresse.adresse3}}
                <br v-if="adresse.adresse1">
                {{adresse.codePostal}}
                {{adresse.ville}}
                {{adresse.pays}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <street-view-panorama
      v-else
      style="width: 100%; height: 500px;"
      :position="this.mark.position"/>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import getLogo from '@/services/general/getLogo';
import { components } from 'gmap-vue';

export default {
  props: {
    mark: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logo: null,
      streetView: false,
    };
  },
  components: {
    StreetViewPanorama: components.StreetViewPanorama,
  },
  computed: {
    client() {
      return this.mark?.client;
    },
    adresse() {
      return this.client.adressePostale ?? {};
    },
  },
  methods: {
    toggleStreetView() {
      this.streetView = !this.streetView;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logo = await getLogo(this.client.id);
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>

</style>
